import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMountedState} from '@s-ui/react-hooks'
import MoleculeCarousel from '@s-ui/react-molecule-carousel'
import {
  imageUrlAdapterImageTypes,
  imageUrlAdapterTransformTypes,
  useImageUrlAdapter
} from '@adv-mt/mt-hook-use-image-url-adapter'

import {
  DEFAULT_THUMBNAILS_SLIDER_OPTIONS,
  TEST_ID_THUMBNAILS_SLIDER,
  THUMBNAIL_WIDTH,
  THUMBNAILS_WRAPPER_CLASS
} from '../../config.js'
import ThumbnailsWrappersSkeleton from './Skeleton.js'
import Thumbnails from './ThumbnailList.js'

const GalleryBasicThumbnailsWrapper = ({hasLazyLoadSlider = true, images, onSelectThumbnail, selectedSlide}) => {
  const {i18n} = useContext(Context)
  const getImagesUrlsAdapted = useImageUrlAdapter()
  const {images: resizedImages} = getImagesUrlsAdapted({
    images,
    options: {
      imageWidth: THUMBNAIL_WIDTH,
      imageType: imageUrlAdapterImageTypes.THUMBNAIL,
      transformType: imageUrlAdapterTransformTypes.DEVICE_CROP
    }
  })
  const getMountedState = useMountedState()
  const isMounted = getMountedState()

  const handleSelectThumbnail = slide => onSelectThumbnail(slide)

  return isMounted ? (
    <div className={THUMBNAILS_WRAPPER_CLASS} data-testid={TEST_ID_THUMBNAILS_SLIDER}>
      <MoleculeCarousel
        {...DEFAULT_THUMBNAILS_SLIDER_OPTIONS}
        arrowLeftLabel={i18n.t('COMMON.PREVIOUS')}
        arrowRightLabel={i18n.t('COMMON.NEXT')}
        doAfterSlide={handleSelectThumbnail}
        slide={selectedSlide}
        lazyLoadSlider={hasLazyLoadSlider}
      >
        {Thumbnails({
          images: resizedImages,
          selectedSlide,
          onClickThumbnail: handleSelectThumbnail
        })}
      </MoleculeCarousel>
    </div>
  ) : (
    <ThumbnailsWrappersSkeleton />
  )
}

GalleryBasicThumbnailsWrapper.displayName = 'GalleryBasicThumbnailsWrapper'
GalleryBasicThumbnailsWrapper.propTypes = {
  forceImageCrop: PropTypes.bool,
  hasLazyLoadSlider: PropTypes.bool,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired,
  onSelectThumbnail: PropTypes.func.isRequired,
  selectedSlide: PropTypes.number
}

export default GalleryBasicThumbnailsWrapper
